import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "pop-up" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "max-w-7xl p-3 rounded-xl shadow-lg bg-white opacity-100" }
const _hoisted_5 = ["src"]

import { store } from "@/main"
import { computed, ref } from "vue"
import OperationDescription from "./popUpContent/OperationDescription.vue"
import IncidentDescription from "./popUpContent/IncidentDescription.vue"
import DeathDescription from "./popUpContent/DeathDescription.vue"
import ShipwreckDescription from "./popUpContent/ShipwreckDescription.vue"
import { PopUpType } from "@/classes/State"

export default /*#__PURE__*/_defineComponent({
  __name: 'PopUp',
  setup(__props) {

function toggleVisibility () {
  store.updatePopUpVisibility()
}
const isPopUpVisible = computed(() => store.getState().isPopUpVisible)
const popUpType = computed(() => store.getState().popUpType)

const isModalVisible = computed(() => store.getState().isImageModalVisible)
function toggleImageModalVisibility () {
  store.updateImageModalVisibility(false)
}
const currentImage = computed(() => store.getState().imageModalUrl)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (isPopUpVisible.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", {
                class: "absolute bg-black opacity-60 inset-0 z-50",
                onClick: toggleVisibility
              }),
              _createElementVNode("div", _hoisted_2, [
                (popUpType.value === _unref(PopUpType).OPS)
                  ? (_openBlock(), _createBlock(OperationDescription, { key: 0 }))
                  : _createCommentVNode("", true),
                (popUpType.value === _unref(PopUpType).INCIDENT)
                  ? (_openBlock(), _createBlock(IncidentDescription, { key: 1 }))
                  : _createCommentVNode("", true),
                (popUpType.value === _unref(PopUpType).DEAD)
                  ? (_openBlock(), _createBlock(DeathDescription, { key: 2 }))
                  : _createCommentVNode("", true),
                (popUpType.value === _unref(PopUpType).SHIPWRECK)
                  ? (_openBlock(), _createBlock(ShipwreckDescription, { key: 3 }))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (isModalVisible.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", {
                onClick: toggleImageModalVisibility,
                class: "image-modal"
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("img", {
                    class: "w-full",
                    src: currentImage.value
                  }, null, 8, _hoisted_5)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})